<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :visible="dialogVisible"
      width="800px"
      append-to-body
      @close="handleClose"
      center>
      <el-form :inline="true">
        <el-form-item>
          <el-input
            style="width: 120px;"
            v-model="centerDialogPlateNum"
            @change="onSubmit(0)"
            @input="onSubmit(0)"
            placeholder="车牌"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(1)">相似车辆</el-button>
          <el-button type="primary" @click="onSubmit(2)">差两位匹配</el-button>
          <el-button type="primary" @click="onSubmit(3)">差三位匹配</el-button>
          <el-button type="primary" @click="onSubmit(-1)">最近当前出口订单</el-button>
        </el-form-item>
      </el-form>
      <div class="plateOrderList" v-if="dialogList.length === 0">
        <el-image :src="require('@/assets/img/nodata02@2x.png')" alt="" style="width: 400px; margin: 0 auto;"></el-image>
      </div>
      <el-radio-group class="plateOrderList" v-model="radioChoose"  @change="handleChoose" v-else>
        <div v-for="(v, i) in dialogList" :key="i" class="item">
          <el-image
            class="img"
            lazy
            style="width: 100%; height: 190px;"
            :src="v.passFullImage"
            :preview-src-list="v.passFullImageArr"
            fit="fill"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              <div style="height: 190px; display: flex; align-items: center;background: #f5f7fa; justify-content: center;">
                暂无图片
              </div>
            </div>
          </el-image>
          <el-radio :label="i" border style="width: 100%;">
            <div style="width: 100%; display: flex; align-items: center; justify-content:space-between; font-size: 14px; color: #666;">
              <span>{{v.plateNumber}}</span>
              <span>{{v.cameAt}}</span>
            </div>
          </el-radio>
        </div>
      </el-radio-group>
      <page-size ref="page" @pageChange="queryList" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button type="warning" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
import { queryParkOrder } from "@/api/module/tenant";
import pageSize from "@/components/PageSize/index";
import { carPass } from "@/api/module/park";

export default {
  components: {
    pageSize
  },
  data: () => ({
    centerDialogPlateNum: '',
    ParkingDiffPlateCharNum: undefined,
    OutGateId: undefined,
    dialogList: [],
    dialogListActive: {
      id: undefined
    },
    radioChoose: ''
  }),
  mixins: [showdialog],
  props: {
  },
  computed: {
    gateId: function () {
      return this.$store.state.order.payOrderGateId;
    },
    isNode: function () {
      let leftGateTab = JSON.parse(this.$store.state.order.leftGateIdTabs);
      let arr = leftGateTab.filter(v => {return this.$store.state.order.payOrderGateId === v.Id && parseInt(sessionStorage.getItem('sentryId')) === v.SentryBoxId});
      return arr.length > 0;
    },
  },
  methods: {
    onSubmit(n) {
      this.ParkingDiffPlateCharNum = n;
      this.radioChoose = '';
      this.dialogListActive = {
        id: undefined,
      };
      this.queryList();
    },
    async queryList() {
      console.log(this.gateId);
      const $page = this.$refs.page;
      let PlateNumber = this.ParkingDiffPlateCharNum > -1 ? this.centerDialogPlateNum : undefined;
      let ParkingDiffPlateCharNum = this.ParkingDiffPlateCharNum > 0 ? this.ParkingDiffPlateCharNum : undefined;
      let OutGateId = this.ParkingDiffPlateCharNum > -1  ? undefined : Number(this.OutGateId);
      let Isleft = this.ParkingDiffPlateCharNum > -1 ? 5 : 2;
      let sortType = this.ParkingDiffPlateCharNum === -1 ? 1 : undefined;
      let res = await queryParkOrder({
        Page: $page ? $page.current : 1,
        PerPage: $page ? $page.pageSize : 20,
        ParkingDiffPlateCharNum: ParkingDiffPlateCharNum,
        ParkLotId: this.$store.state.order.parkLotId,
        OutGateId: OutGateId,
        orderNo: "",
        PlateNumber: PlateNumber,
        orderType: "全部",
        IsLimitDate: 1,
        Isleft: Isleft,
        sortType: sortType,
        QueryAll: true,
        GateQuery: true,
        curSentry: sessionStorage.getItem('sentryName'),
      });
      if (res.state === "success") {
        this.dialogList = res.data.map(v => {
          v.passFullImage = v.passInFullImage === '' ? v.passOutFullImage : v.passInFullImage;
          v.passFullImageArr = [v.passFullImage];
          return v
        });
        if ($page) $page.total = res.pageInfo.Total;
      }
      if(this.dialogList.length === 0 && this.ParkingDiffPlateCharNum === 0) {
        this.onSubmit(1)
      }
    },
    handleChoose() {
      this.dialogListActive = this.dialogList[this.radioChoose];
    },
    async handleSubmit() {
      if(!this.dialogListActive.id){
        this.$message({ message: '未选择任何记录，请选择', type: "error" });
        return;
      }
      if (!this.gateId || !this.isNode) {
        this.$emit('noOutGateId');
        return;
      }
      // console.log(this.dialogListActive)
      let res = await carPass({
        ParkLotId: this.dialogListActive.parkLotId,
        ParkLotGateId: this.gateId,
        PlateNumber: this.dialogListActive.plateNumber,
        PlateColor: this.dialogListActive.plateColor,
        Direction: 2,
        WaitTime: this.formatDateTime(new Date())
      });
      if (res.state === "failed") {
        this.$message.error(res.message);
      }
      // orderPubSub.publish(this.dialogListActive);
      // this.$store.dispatch("GetWsOrderArr", this.dialogListActive);
      this.handleClose();
    },
  },
};
</script>

<style>
  .plateOrderList .el-radio{
    display: flex;
    margin-top: 5px;
    padding-right: 0;
    padding-left: 0;
    border: none;
  }
.plateOrderList .el-radio .el-radio__label{
  width: calc(100% - 15px);
}
</style>
